module.exports = __webpack_public_path__ + "static/media/task-manager.a8138d45.png";